import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type AlertType = "message" | "discount";

export type AlertInfo = {
  id: string;
  type: AlertType;
  title: string;
  text: string;
  creationDateTime?: Date;
};

interface AlertState {
  alerts: AlertInfo[];
  addAlert: (command: AlertInfo) => void;
  removeItem: (id: string) => void;
}

const useAlertStore = create<AlertState>()(
  devtools(
    persist(
      (set) => ({
        alerts: [],
        addAlert: (command) =>
          set((state) => ({ alerts: [...state.alerts, command] })),
        removeItem: (id: string) =>
          set((state) => ({ alerts: state.alerts.filter((x) => x.id !== id) })),
      }),
      { name: "customerClubStore" }
    )
  )
);

export default useAlertStore;
